export default __webpack_public_path__ + "static/media/renuma-plus-03.f2deda9f.png";